// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import preloadImages from '../../../../../utils/preloadImages';

// Components
import FileUploadPopup from './popup/FileUploadPopup';
import TooltipSource from '../../../../../components/tooltips/TooltipSource';
import ToolbarPopupTool from '../../ToolbarPopupTool';

// Actions
import { closePopup } from '../../../../../components/popupPanel/popupActions';

// Constants
import { TooltipPositions } from '../../../../../components/tooltips/tooltipConstants';
import { TIMES } from '../../../../../../common/utils/timeUtil';

// Styles
import './FileTool.scss';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    closeFilePopup: () => dispatch(closePopup(PopupIds.FILE_UPLOAD)),
});

class FileTool extends React.Component {
    componentDidMount() {
        preloadImages([require('./popup/file-upload-form-illustration.png')]);
    }

    render() {
        const { tooltipEnabled } = this.props;

        return (
            <div className="FileTool">
                <TooltipSource
                    tooltipText="Click me"
                    position={TooltipPositions.RIGHT}
                    distance={5}
                    duration={TIMES.SECOND * 5}
                    enabled={tooltipEnabled}
                    fade
                    triggerOnDrag
                >
                    <ToolbarPopupTool
                        {...this.props}
                        name="Upload"
                        toolName="upload"
                        popupId={PopupIds.FILE_UPLOAD}
                        PopupComponent={FileUploadPopup}
                    />
                </TooltipSource>
            </div>
        );
    }
}

FileTool.propTypes = {
    openFilePopup: PropTypes.func,
    closeFilePopup: PropTypes.func,
    popupIsOpen: PropTypes.bool,
    currentBoardId: PropTypes.string,
    tooltipEnabled: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(FileTool);
